<template>
  <el-dialog
    title="批量生成商品编码"
    :visible.sync="visible"
    width="600px"
    :top="200"
    >
    <el-form label-width="72px">
      <el-form-item label="生成规则：">
        <div class="rule-list">
          <div class="rule-list__item" v-for="rule in ruleValueOpts" :key="rule.value">
            <el-radio v-model="ruleValue" :label="rule.value">{{rule.label}}</el-radio>
            <el-select v-if="rule.value == 5" v-model="newOuterId" :key="newOuterIdSelectKey" allow-create filterable placeholder="请输入新的商品编码"
              @change="newOuterIdChange">
              <el-option v-for="item in [copy_outerId]"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <span v-if="rule.example" class="example">举例：{{ rule.example }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="分隔规格：">
        <div>
          <el-checkbox v-model="isUseSymbol">用符号</el-checkbox>
          <el-input style="width:32px" :disabled="!isUseSymbol" v-model="symbol" maxlength="1"></el-input><span style="font-size:12px;">分隔规格值</span>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" style="text-align: right" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 批生成skuOuterId
import { getPinyinArr } from '@/servers/prod/center/index.js'
export default {
  data() {
    return {
      field_key: 'skuOuterId',
      visible: false,
      copy_skuList: [],
      copy_outerId: '',
      cb: null, // 生成成功的回调

      ruleValue: '2', // 生成规则
      isUseSymbol: false, // 是否使用分隔符
      symbol: '', // 分隔符
      newOuterId: '',

      ruleValueOpts: [ // 生成规则的选项
        {label: '款式编码+序号', value: '1', example: '18k1001-1'},
        {label: '款式编码+规格值', value: '2', example: '18k1001-红色-X'},
        {label: '款式编码+规格值(拼音)', value: '3', example: '18k1001-HONGSE-X'},
        {label: '原商品编码+规格值', value: '4'},
        {label: '统一覆盖更新为', value: '5'},
      ],
      newOuterIdSelectKey: Date.now(), // 新商品编码select的key，用于输入值超长时重置select UI
    }
  },
  watch: {
    visible(v) {
      if(!v) {
        this.copy_skuList = []
        this.copy_outerId = ''
        this.cb = null
        this.newOuterId = '';
      }
    }
  },
  methods: {
    method_open({skuList, outerId, field} = {}, cb) {
      if (skuList) {
        this.copy_skuList = JSON.parse(JSON.stringify(skuList))
      }
      if (field) {
        this.field_key = field;
      }
      this.initLocalData()
      this.copy_outerId = outerId
      this.cb = cb;
      this.visible = true
    },
    async handleOk() {
      if (this.ruleValue == '5' && !this.newOuterId)  {
        return this.$message.error('请输入或选择新的商品编码');
      }

      const {ruleValue, isUseSymbol, symbol, copy_skuList, copy_outerId} = this;
      let _symbol = isUseSymbol ? symbol : ''
      let skuList = await this['gen'+ruleValue](copy_skuList, copy_outerId, _symbol)
      this.visible = false
      if (skuList && this.cb) {
        this.cb(skuList)
        this.setLocalData()
      }
    },
    // 编码加序号
    async gen1(skuList, outerId, symbol) {
      return skuList.map((sku, skuIndex) => {
        // 使用 padStart 方法在 skuIndex+1 的字符串前面补零，直到长度为 3
        const paddedSkuIndex = (skuIndex + 1).toString().padStart(3, '0');
        const skuOuterId = [outerId, paddedSkuIndex].join(symbol);
        return {
          ...sku,
          [this.field_key]: skuOuterId
        }
      })
    },
    // 编码加规格值
    async gen2(skuList, outerId, symbol) {
      return skuList.map((sku) => {
        const skuOuterId = [outerId].concat(sku.skuSpecifications.map(sp => sp.value)).join(symbol)
        return {
          ...sku,
          [this.field_key]:skuOuterId
        }
      })
    },
    // 编码加规格值(拼音)
    async gen3(skuList, outerId, symbol) {
      let skuOuterIdArr = []
      skuList.forEach((sku) => {
        skuOuterIdArr.push([outerId].concat(sku.skuSpecifications.map(sp => sp.value)).join(symbol))
      })
      let pinyinArr =  await getPinyinArr(skuOuterIdArr)
      if (!pinyinArr) return false
      
      return skuList.map((sku, skuindex) => {
        return {
          ...sku,
          [this.field_key]: pinyinArr[skuindex]
        }
      })
    },
    // 原商品编码加规格值
    async gen4(skuList, outerId, symbol) {
      return skuList.map((sku) => {
        const originSkuOuterId = sku[this.field_key];
        const skuOuterId = [originSkuOuterId].concat(sku.skuSpecifications.map(sp => sp.value)).filter(Boolean).join(symbol);
        return {
          ...sku,
          [this.field_key]:skuOuterId
        }
      })
    },
    // 统一覆盖更新
    async gen5(skuList, outerId, symbol) {
      return skuList.map((sku) => {
        return {
          ...sku,
          [this.field_key]: this.newOuterId || '',
        }
      })
    },
    // 需要记录上次操作
    // initLocalData 在打开弹窗时调用
    // setLocalData 在成功处理后调用
    initLocalData() {
      let localData = window.localStorage.getItem('_genskuouterid')
      if (!localData) {
        return ;
      }
      localData = JSON.parse(localData)
      this.ruleValue = localData.ruleValue
      this.isUseSymbol = localData.isUseSymbol
      this.symbol = localData.symbol
    },
    setLocalData() {
      let localData = {
        ruleValue: this.ruleValue,
        isUseSymbol: this.isUseSymbol,
        symbol: this.symbol
      }
      window.localStorage.setItem('_genskuouterid', JSON.stringify(localData))
    },
    newOuterIdChange(val) {
      if (val.length > 1024) {
        this.$message.error('输入字符上限为1024位');
        this.newOuterId = '';
        this.newOuterIdSelectKey = Date.now();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  font-size: 12px;
}
.rule-list {
  .rule-list__item {
    margin-bottom: 5px;
  }
}
.example {
  margin-left: 10px;
  padding: 0px 10px;
  background-color: #ddd;    
}
</style>